import { ISessionChoice } from "@crunchit/types";
import { getSummarizedChoices } from "utils/helpers/orderlist";

export default function ChoiceListNames({ modifierIds, choices }: { modifierIds: number[]; choices: ISessionChoice[] }) {
  const getChoicesForModifierId = (modifierId: number, choices: ISessionChoice[]) => {
    return getSummarizedChoices(choices.filter((choice) => choice.modifierId === modifierId));
  };

  return (
    <>
      {modifierIds.map((modifierId) => {
        return (
          <ul key={`${modifierId}-names`} className="orderlist-item-choice-list choices-name">
            {getChoicesForModifierId(modifierId, choices).map((choice) => {
              return <li key={choice.id}>{choice.name}</li>;
            })}
          </ul>
        );
      })}
    </>
  );
}
